import React, { useState } from 'react';
import WelcomeTemplate from '../../templates/Welcome';

export default (props) => {
  return <WelcomeTemplate load={props.load}>{props.children}</WelcomeTemplate>;
};
